var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F2F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 26.2834V29.0334C30.0833 32.7001 28.6166 34.1667 24.9499 34.1667H21.4666C17.7999 34.1667 16.3333 32.7001 16.3333 29.0334V25.5501C16.3333 21.8834 17.7999 20.4167 21.4666 20.4167H24.2166",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.083 26.2834H27.1496C24.9496 26.2834 24.2163 25.5501 24.2163 23.3501V20.4167L30.083 26.2834Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1331 15.8333H28.7997",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9167 18.5833C20.9167 17.0616 22.1451 15.8333 23.6667 15.8333H26.0684",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6671 21.3333V27.0074C34.6671 28.4283 33.5121 29.5833 32.0913 29.5833",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 21.3333H31.9167C29.8542 21.3333 29.1667 20.6458 29.1667 18.5833V15.8333L34.6667 21.3333Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleFiles);
export default __webpack_public_path__ + "static/media/multiple-files.2f57de35fe148d603b6936fb57ed1e95.svg";
export { ForwardRef as ReactComponent };